import { Action, createReducer, on } from '@ngrx/store';
import * as InfoBannerActions from '../actions/info-banner.actions';

export const INFO_BANNER_FEATURE_KEY = 'infoBanner';

export interface State {
  showBanner: boolean;
  message: string;
  closeButtonText?: string;
  closeButtonAction?: Action;
  primaryButtonText?: string;
  primaryButtonAction?: Action;
  showBannerWithError?: boolean;
}

export const initialState: State = {
  showBanner: false,
  message: '',
};

export const reducer = createReducer(
  initialState,
  on(
    InfoBannerActions.openInfoBanner,
    (
      state,
      {
        message,
        closeButtonText,
        closeButtonAction,
        primaryButtonText,
        primaryButtonAction,
        showBannerWithError,
      }
    ) => ({
      ...state,
      showBanner: true,
      message,
      closeButtonText,
      closeButtonAction,
      primaryButtonText,
      primaryButtonAction,
      showBannerWithError,
    })
  ),
  on(InfoBannerActions.closeInfoBanner, () => ({
    ...initialState,
  }))
);
